// removed by extract-text-webpack-plugin
module.exports = {"receipt-total-box":"app-components-receipt-transactions-Total-__style___hDdBY","receipt-total":"app-components-receipt-transactions-Total-__style___1pJP2","overflow-word":"app-components-receipt-transactions-Total-__style___Tljj1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/Total/style.css
// module id = 818
// module chunks = 0